"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateTick = exports.reset = exports.get = void 0;
var diveCrew_hero_sidecar_1 = require("@voyage/crew/diveCrew_hero-sidecar");
var voyageWebsockets_sidecar_1 = require("@voyage/multi-sockets/voyageWebsockets-sidecar");
var diveMessage_hostCommand_1 = require("@voyage/multi/diveMessage_hostCommand");
var diveMessage_hostCommand_sidecar_1 = require("@voyage/multi/diveMessage_hostCommand-sidecar");
var diveMessage_simulationSync_sidecar_1 = require("@voyage/multi/diveMessage_simulationSync-sidecar");
var _obj = null;
var get = function () {
    if (!_obj) {
        _obj = {
            ticks_to_transition: 0,
            levelNum: 1,
            isSafeRoom: false,
        };
        exports.reset();
    }
    return _obj;
};
exports.get = get;
var reset = function () {
    var obj = exports.get();
    obj.ticks_to_transition = 0;
};
exports.reset = reset;
function updateTick() {
    var obj = exports.get();
    // Count how many heroes are alive and how many are in the stairs waiting for the next level
    var alive = diveCrew_hero_sidecar_1.diveCrew_hero.countLiveHeroes();
    var waiting = diveCrew_hero_sidecar_1.diveCrew_hero.countLiveHeroesWaitingForNextLevel();
    if (alive > 0) {
        if (waiting >= alive) {
            // Go to the next level
            obj.ticks_to_transition++;
            if (obj.ticks_to_transition >= 16) {
                if (voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost()) {
                    diveMessage_simulationSync_sidecar_1.diveMessage_simulationSync.send(false);
                    diveMessage_hostCommand_sidecar_1.diveMessage_hostCommand.sendMessageToAll({
                        hostCommand: diveMessage_hostCommand_1.EDiveHostCommand.NextLevel,
                        message: 'Going to new level...',
                    });
                    obj.ticks_to_transition = 0;
                }
            }
        }
    }
    else {
        // Everyone is dead, game over screen?
    }
}
exports.updateTick = updateTick;
